import type {
  Address,
  CreateAddressPayload,
  UpdateAddressPayload,
  AddressResponse,
  DeleteAddressResponse,
  SetDefaultAddressResponse,
} from '../model/types'
import { useApi } from '@shared/api'

/**
 * API-клиент адресов доставки пользователя.
 * Базовый URL: /api/v2/users/addresses
 */
class APIAddress {
  async getAddresses(): Promise<Address[]> {
    const response = await useApi(true).get('/users/addresses')

    if (Array.isArray(response.data)) return response.data
    if (Array.isArray(response.data?.addresses)) return response.data.addresses

    return []
  }

  async createAddress(payload: CreateAddressPayload): Promise<AddressResponse> {
    const response = await useApi(true).post('/users/addresses', { body: payload })
    return response.data
  }

  async updateAddress(addressId: string, payload: UpdateAddressPayload): Promise<AddressResponse> {
    const response = await useApi(true).put(`/users/addresses/${addressId}`, { body: payload })
    return response.data
  }

  async deleteAddress(addressId: string): Promise<DeleteAddressResponse> {
    const response = await useApi(true).delete(`/users/addresses/${addressId}`)
    return response.data
  }

  async setDefaultAddress(addressId: string): Promise<SetDefaultAddressResponse> {
    const response = await useApi(true).post(`/users/addresses/${addressId}/set-default`)
    return response.data
  }
}

export const apiAddress = new APIAddress()
export default apiAddress
